import { render, staticRenderFns } from "./InsuranceCompanyServiceBtns.vue?vue&type=template&id=ed0d699a&"
import script from "./InsuranceCompanyServiceBtns.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyServiceBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports